import React from 'react';
import './Switch.css';

const Switch = ({ isOn, handleToggle, switchText = '', id = '', color = '', disabled = false }) => {
  return (
    <div className="react-switch-container">
      <span className="react-switch-text">{switchText}</span>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`react-switch-new-${id}`}
        type="checkbox"
        disabled={disabled}
      />
      <label
        style={{ background: isOn && `${color}` || isOn && '#06D6A0' }}
        className="react-switch-label"
        htmlFor={`react-switch-new-${id}`}
      >
          <span className={`react-switch-button`} />
      </label>
    </div>
  );
};

export default Switch;